import { ReducerState } from "./make-reducer";
import { findKeyInObj } from "../../../../../common/utils/object";
import {
  LoadStatusWithFetchDetail,
  DetailedLoadStatus,
} from "../../../../../common/utils/async-status";

export function makeSelectors<T = any>(nodeName: string) {
  function getBaseState(state): ReducerState {
    return findKeyInObj(state, nodeName);
  }

  /**
   * The reducer supports re-fetching to refresh the data, but does not
   * nuke existing data until the fetch is complete.
   * This tells you whether ANY fetch is in progress.
   * @see getResultStatus
   */
  function getFetchStatus(state): DetailedLoadStatus {
    const status = getBaseState(state).fetchState.status;
    if (status === LoadStatusWithFetchDetail.WAITING) {
      return DetailedLoadStatus.WAITING;
    } else if (status === LoadStatusWithFetchDetail.FETCHING) {
      return DetailedLoadStatus.FETCHING;
    }

    const ok = isOk(state);
    if (ok) {
      return DetailedLoadStatus.OK;
    }
    return DetailedLoadStatus.ERROR;
  }

  /**
   * The reducer supports re-fetching to refresh the data, but does not
   * nuke existing data until the fetch is complete.
   * This tells you whether you have ANY valid data or are still in the
   * initial fetch
   * @see getFetchStatus
   */
  function getResultStatus(state): DetailedLoadStatus {
    const fetchStatus = getFetchStatus(state);
    const resultOk = isOk(state);
    if (fetchStatus === DetailedLoadStatus.WAITING) {
      return DetailedLoadStatus.WAITING;
    } else if (typeof resultOk === "boolean") {
      if (resultOk) {
        return DetailedLoadStatus.OK;
      } else {
        return DetailedLoadStatus.ERROR;
      }
    }
    return DetailedLoadStatus.FETCHING;
  }

  function getData(state): T {
    return getBaseState(state).resultState.data;
  }

  function isOk(state) {
    return getBaseState(state).resultState.isOk;
  }

  function getResultStatusCode(state): number | undefined {
    return getBaseState(state).resultState.resultStatus;
  }

  return {
    getFetchStatus,
    getResultStatus,
    getData,
    getResultStatusCode,
  };
}
